export default (inputEl) => {
  inputEl.select();
  inputEl.classList.add("focused");
  window.document.execCommand("copy");
};
